module.exports = __webpack_public_path__ + "static/media/at.5ab33f74.svg";